// src/ApiPanel/pages/ca/UploadPages.jsx
// The three upload screens. Same flow, different columns and endpoint.
import React from "react";
import UploadReport from "../../components/reports/UploadReport";
import { Notice } from "../../components/reports/ReportKit";
import { API_PANEL_ENDPOINTS } from "../../constants/apiPanelAuth";

const INVOICE_COLUMNS = [
  { key: "supplier_gstin", label: "Supplier GSTIN" },
  { key: "invoice_no", label: "Invoice No" },
  { key: "invoice_date", label: "Date" },
  { key: "taxable_value", label: "Taxable" },
  { key: "gst_rate", label: "Rate" },
];

export function UploadGst() {
  return (
    <UploadReport
      title="Upload GST"
      subtitle="Bulk-load vendor invoices into the inward-supply register so their input credit shows in GST Information."
      uploadType="GST"
      endpoint={API_PANEL_ENDPOINTS.CA_UPLOAD_GST}
      columns={INVOICE_COLUMNS}
      guidance={
        <Notice tone="warn">
          Each row&rsquo;s declared tax must match its rate applied to its taxable value, within a
          rupee. A row claiming more credit than the rate implies is rejected — that check is the
          reason this upload exists rather than a direct database load.
        </Notice>
      }
    />
  );
}

export function UploadGstRecharge() {
  return (
    <UploadReport
      title="Upload GST Recharge"
      subtitle="Operator commission invoices for recharge, loaded into the inward-supply register."
      uploadType="GST_RECHARGE"
      endpoint={API_PANEL_ENDPOINTS.CA_UPLOAD_GST_RECHARGE}
      columns={[{ key: "operator", label: "Operator" }, ...INVOICE_COLUMNS]}
      guidance={
        <Notice tone="info">
          An invoice number that already exists in the register for the same supplier GSTIN is
          rejected as a duplicate, so re-uploading an overlapping month is safe.
        </Notice>
      }
    />
  );
}

export function UploadCashDeclaration() {
  return (
    <UploadReport
      title="Upload Cash Declaration"
      subtitle="Bulk-file daily cash declarations on behalf of retailers. Each becomes a Submitted declaration awaiting review."
      uploadType="CASH_DECLARATION"
      endpoint={API_PANEL_ENDPOINTS.CA_UPLOAD_CASH_DECLARATION}
      columns={[
        { key: "user_phone", label: "Retailer Phone" },
        { key: "declared_for", label: "For Date" },
        { key: "opening_cash", label: "Opening" },
        { key: "cash_collected", label: "Collected" },
        { key: "cash_deposited", label: "Deposited" },
        { key: "closing_cash", label: "Closing" },
      ]}
      guidance={
        <Notice tone="warn">
          Committing this file files declarations <em>in the retailers&rsquo; names</em>. Each one
          still has to be approved individually afterwards, and every row records that it arrived
          through this batch rather than from the retailer directly.
        </Notice>
      }
    />
  );
}
